import { render, staticRenderFns } from "./ListBusiness.vue?vue&type=template&id=edf5750c&"
import script from "./ListBusiness.vue?vue&type=script&lang=js&"
export * from "./ListBusiness.vue?vue&type=script&lang=js&"
import style0 from "./ListBusiness.vue?vue&type=style&index=0&id=edf5750c&prod&scroped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports